import Button from '@mui/material/Button';
import Show from './utility/Show';

const useStyles = ({ size, color }) => ({
  button: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'rgb(34, 70, 127)',
    background: 'none',
    border: 'none',
    marginRight: '10px',
  },
  icon: {
    padding: 5,
    color: color || 'rgb(34, 70, 127)',
    width: size || 36,
    height: size || 36,
  },
});

const IconButton = ({ onClick = () => {}, Icon, text, selected, size, href, color }) => {
  const styles = useStyles({ selected, size, color });
  const buttonProps = {
    style: styles.button,
    className: 'icon-text-button',
  };
  if (href) {
    buttonProps.href = href;
    buttonProps.component = 'a';
  } else {
    buttonProps.type = 'button';
    buttonProps.onClick = onClick;
    buttonProps.component = 'button';
  }
  return (
    <>
      {/* necessary to add hover styles */}
      <style>
        {`
        .icon-text-button:hover {
          cursor: pointer;
        }
      `}
      </style>
      <Button {...buttonProps}>
        <Icon style={styles.icon} />
        <Show test={text}>
          {text}
        </Show>
      </Button>
    </>
  );
};

export default IconButton;
